import { render } from "./float-button.vue?vue&type=template&id=0d6db564&scoped=true"
import script from "./float-button.vue?vue&type=script&lang=js"
export * from "./float-button.vue?vue&type=script&lang=js"

import "./float-button.vue?vue&type=style&index=0&id=0d6db564&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6db564"]])

export default __exports__